import React from 'react'
import './Newsletter.css'


const Newsletter = () => {
    // const [email, setEmail] = useState("");

    // const handleSubscribe = async () => {
    //     const res = await fetch("http://localhost:4000/subscribe", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({ email }),
    //     });

    //     const data = await res.json();
    //     alert(data.message);
    // };
    return (
        <div className='newsletter' >

            <div className="nl-left">
                <h2>Capture sound like the movies</h2>
                <h3>stay tuned for pro <span>audio gear updates!</span> </h3>
                {/* <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                /> <button className='newsletter-btn' onClick={handleSubscribe}>Join the Soundcheck</button> */}
                </div> 

        </div>
    )
}


export default Newsletter